// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/wing-planform.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/wing-planform/wing-planform.js';

mount([g0]);
